<template>
  <div class="mod_footer">
    <div class="main_contain">
      <div class="footer_t_box">
        <div class="footer_tl_box">
          <div class="footer_logo_box">
            <img class="logo_img" src="../assets/img/logo_white.png" alt="" />
          </div>
          <div class="footer_bottom_box">
            <div class="b_item_lt">
              <div class="bit_tt bit_tt2">广州有济于世信息科技有限公司</div>
            </div>

            <div class="b_item_lt">
              <div class="bit_tt">
                地址：广州市珠江新城兴民路222号天盈广场西塔1905室
              </div>
            </div>

            <div class="b_item_lt">
              <div class="bit_tt">邮箱：info@gigitech.cn</div>
            </div>
          </div>
        </div>

        <div class="footer_t_line"></div>

        <div class="footer_m_box">
          <div class="footer_tr_box">
            <div class="footer_ttb_box">
              <div class="tr_item_tt" @click="activeToPart(1)">首页</div>
              <div class="tr_item_tt" @click="activeToPart(2)">关于我们</div>
              <div class="tr_item_tt" @click="activeToPart(3)">平台介绍</div>
              <div class="tr_item_tt" @click="activeToPart(4)">解决方案</div>
              <div class="tr_item_tt" @click="activeToPart(5)">信息安全</div>
              <div class="tr_item_tt" @click="activeToPart(6)">联系我们</div>
              <div class="tr_item_tt" @click="activeToPart(7)">招纳贤士</div>
              <div class="tr_item_tt" @click="activeToPart(8)">下载中心</div>
              <div class="tr_item_tt"></div>
            </div>
          </div>

          <div class="footer_t_line"></div>

          <div class="footer_tr_rt">
            <div class="tr_rt_wxcode_box">
              <div class="tr_rt_title">企业微信二维码：</div>
              <div class="tr_rt_wxcode">
                <img
                  class="rt_wxcode_img"
                  src="@/assets/img/company_wx_code.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_beian">
        ©2025 广州有济于世信息科技有限公司版权所有<br
          class="visible-xs-block"
        /><a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
          >粤ICP备2022140737号</a
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { emitEvent } from "@/utils/eventBus";

const activeToPart = (index) => {
  emitEvent("partIndex", index);
};
</script>

<style lang="scss" scoped>
$r: 50;

.mod_footer {
  background: #25b3a8;
  padding: 30px 0;
  display: flex;
  color: #fff;
  height: 420px;

  .main_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  .footer_t_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0;
    height: 200px;
    .footer_tl_box {
      display: flex;
      flex-direction: column;
      width: 33%;
      .footer_logo_box {
        display: flex;
        margin-bottom: 20px;
        .logo_img {
          width: 180px;
        }
      }
    }
    .footer_m_box {
      display: contents;
    }
    .footer_t_line {
      width: 1px;
      height: 180px;
      background: #fff;
    }

    .footer_tr_rt {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: calc(26% - 2px);
      .tr_rt_wxcode_box {
        width: 200px;
        text-align: center;
      }
      .tr_rt_title {
        font-size: 16px;
        margin-bottom: 30px;
      }

      .tr_rt_wxcode {
        border-radius: 20px;
        .rt_wxcode_img {
          width: 150px;
        }
      }
    }

    .footer_tr_box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 40%;
      padding: 0 150px;
      .footer_ttb_box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        justify-content: center;
      }
      .tr_item_tt {
        width: 120px;
        font-size: 20px;
        text-align: left;
        cursor: pointer;
        margin: 20px 0;

        &:hover {
          font-weight: bold;
        }
      }
    }
  }

  .line_border {
    height: 1px;
    width: 100%;
    margin: 40px 0;
  }

  .footer_bottom_box {
    letter-spacing: 1px;
    .footer_title {
      font-size: 16px;
      text-align: left;
      margin-bottom: 10px;
      line-height: 24px;
    }

    .b_item_lt {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .bit_tt {
        font-size: 18px;
      }
      .bit_tt2 {
        font-size: 24px;
      }
    }
  }

  .footer_beian {
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    a {
      margin-left: 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 1800px) {
  .mod_footer {
    .footer_t_box {
      .footer_tr_box {
        padding: 0 100px;
      }
    }
  }
}

@media (max-width: 1600px) {
  .mod_footer {
    background: #25b3a8;
    padding: 30px 0;
    display: flex;
    color: #fff;
    height: 420px;

    .footer_t_box {
      margin: 30px 0;
      .footer_tl_box {
        width: 33%;
        text-align: left;
        .footer_logo_box {
          display: flex;
          margin-bottom: 25px;
          .logo_img {
            width: 160px;
          }
        }
      }

      .footer_t_line {
        width: 1px;
        max-width: 1px;
        height: 180px;
        background: #fff;
      }

      .footer_tr_rt {
        width: calc(26% - 2px);
        .tr_rt_wxcode {
          border-radius: 20px;
          .rt_wxcode_img {
            width: 150px;
          }
        }
      }

      .footer_tr_box {
        width: 40%;
        padding: 0 50px;
        .tr_item_tt {
          width: 120px;
          font-size: 20px;
          margin: 20px 0;
        }
      }
    }

    .line_border {
      height: 1px;
      width: 100%;
      margin: 40px 0;
    }

    .footer_bottom_box {
      letter-spacing: 1px;
      .footer_title {
        font-size: 16px;
        text-align: left;
        margin-bottom: 10px;
        line-height: 24px;
      }

      .b_item_lt {
        margin-bottom: 20px;
        .bit_tt {
          font-size: 16px;
        }
        .bit_tt2 {
          font-size: 22px;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .mod_footer {
    background: #25b3a8;
    padding: 20rem / $r;
    display: flex;
    color: #fff;
    height: auto;

    .footer_t_box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      height: 100%;
      font-size: 12rem / $r;
      width: 100%;
      padding-bottom: 60rem / $r;
      .footer_tl_box {
        display: flex;
        flex-direction: column;
        width: 100%;
        .footer_logo_box {
          display: flex;
          margin-bottom: 10rem / $r;
          .logo_img {
            width: 100rem / $r;
          }
        }
      }

      .footer_m_box {
        display: flex;

        .footer_t_line {
          width: 1px;
          min-width: 1px;
          height: 100%;
          min-height: 100%;
          margin: 0;
        }
        .footer_tr_box {
          width: calc(60% - 1px);
        }
        .footer_tr_rt {
          width: 40%;
        }
      }

      .footer_t_line {
        width: 100%;
        min-width: 100%;
        height: 1px;
        min-height: 1px;
        background: #ffffff5d;
        margin: 10rem / $r;
      }

      .footer_tr_rt {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 100%;
        .tr_rt_wxcode_box {
          width: 100%;
          text-align: center;
        }
        .tr_rt_title {
          font-size: 10rem / $r;
          margin-bottom: 10rem / $r;
        }

        .tr_rt_wxcode {
          .rt_wxcode_img {
            width: 60rem / $r;
          }
        }
      }

      .footer_tr_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        padding: 0;
        .footer_ttb_box {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          justify-content: flex-start;
        }
        .tr_item_tt {
          width: auto;
          font-size: 12rem / $r;
          text-align: left;
          cursor: pointer;
          margin: 6rem / $r 10rem / $r;
          margin-left: 0;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }

    .line_border {
      height: 1px;
      width: 100%;
      margin: 40px 0;
    }

    .footer_bottom_box {
      letter-spacing: 1px;
      .footer_title {
        font-size: 16rem / $r;
        text-align: left;
        margin-bottom: 10rem / $r;
        line-height: 24rem / $r;
      }

      .b_item_lt {
        display: flex;
        align-items: center;
        margin-bottom: 4rem / $r;
        &:last-child {
          margin-bottom: 0;
        }
        .bit_tt {
          font-size: 12rem / $r;
        }
        .bit_tt2 {
          font-size: 12rem / $r;
        }
      }
    }

    .footer_beian {
      font-size: 10rem / $r;
      line-height: 22rem / $r;
      text-align: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      a {
        margin-left: 0;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
